import { Injectable } from '@angular/core';

@Injectable({ providedIn: "root" })

export class BeneficiaryIdsService {


  private minBeneficiaryId = 2;
  private maxIndex = 1;

  public resetMax() {
    this.maxIndex = 1;
  }

  public itemVerifyHasId(item: models.BeneficiaryListVM, itemList: models.BeneficiaryListVM[], isLegalRepresentative:boolean) {
    if (item.beneficiaryID === null || item.beneficiaryID === undefined) {
      const newMax = this.getMaxId(itemList, isLegalRepresentative);
      if (this.maxIndex < newMax) {
        this.maxIndex = newMax + 1;
        if (this.maxIndex == 1) {
          this.maxIndex = 2;
        }
      } else {
        if (isLegalRepresentative) {
          this.maxIndex++;
        } else {
          if (newMax == 0 && this.maxIndex==1) {
            this.maxIndex = 1;
          } else {
            this.maxIndex++;
          }
        }
        
      }
      item.beneficiaryID = this.maxIndex;
    }
  }

  public fixTheIdsWhenSenderIsNotHabilitandoDeprecated(workflowInstance: models.WorkflowTemplateVM_PM) {
    //É preciso cuidado para seguir em frente, pois a ideia é alterar o beneficiarios ID's e isso tem que ser feito condicionalmente

    // Verificar se existe algum beneficiarioId == 1, se existir retorna sem fazer nada
    const existeIdIgualA1 = workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList
      .filter(el => el.beneficiaryID === 1).length > 0;
    if (existeIdIgualA1) {
      return;
    }

    // É necessario avaliar se ainda não existem documentos, se existirem retorna
    const existemDocumentos = workflowInstance.StepDocumentsPM.DocumentationPM.documentsList.length > 0;
    if (existemDocumentos) {
      // verifica se estão todos vazios
      const elemVazios = workflowInstance.StepDocumentsPM.DocumentationPM.documentsList
        .filter(el => el.designationTypeCode == null);
      if (elemVazios.length != workflowInstance.StepDocumentsPM.DocumentationPM.documentsList.length) {
        return;
      }
    }

    const existeNomeBeneficiario = workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList
      .filter(el => el.beneficiaryName?.length >0).length > 0;
    if (existeNomeBeneficiario) {
      return;
    } 
    // Ok, condições encontradas

    const arrayList = [...workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList];
    let arrayIndex = 1;
    arrayList.forEach(el => el.beneficiaryID = arrayIndex++);
    workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList = [...arrayList];
  }

  private getMaxId(itemList: models.BeneficiaryListVM[], isLegalRepresentative: boolean): number {
    if (itemList.length == 0) {
      if (isLegalRepresentative) {
        return this.minBeneficiaryId - 1;
      } else {
        return 0;
      }
    } else {
      return itemList.reduce((a, b) => a.beneficiaryID > b.beneficiaryID ? a : b).beneficiaryID;
    }
  }


}
